import dayjs from "dayjs";

export function normalizeHomeActivities(groups) {
  const activities = [];

  (groups || []).forEach((group) => {
    (group.data || []).forEach((item) => {
      if (item && item.activity && item.activity.id) {
        activities.push({
          ...item.activity,
          recentAvatars: item.recentAvatars || [],
        });
      }
    });
  });

  return activities.slice(0, 3);
}

export function getActivityStatusText(status) {
  if (status === 1) return "未开始";
  if (status === 2) return "进行中";
  if (status === 3) return "已结束";
  return "";
}

export function isOnlineLocation(location) {
  return (
    location &&
    (location.includes("http://") || location.includes("https://"))
  );
}

export function formatActivityTime(activity, locale = "zh-CN") {
  if (!activity || !activity.startTime || !activity.endTime) {
    return null;
  }

  const startDate = dayjs(activity.startTime);
  const endDate = dayjs(activity.endTime);
  const isEnglish = locale !== "zh-CN";

  return {
    date: isEnglish
      ? startDate.format("MMM D")
      : `${startDate.format("M")}月${startDate.format("D")}日`,
    time: `${startDate.format("HH:mm")}-${endDate.format("HH:mm")}`,
  };
}
